import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppGlobals } from "src/app/app.globals";
import { EmailReportConfigItem } from "src/app/interfaces/entities/email-report";
import { ConfigService } from "src/app/services/config.service";
import { EmailReportRole } from "src/app/interfaces/enums/email-report-role";
import { EntraUser } from "src/app/interfaces/entities/user";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxDropDownBoxModule,
  DxListModule,
  DxTagBoxModule,
  DxToastModule,
} from "devextreme-angular";

import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
@Component({
    selector: "app-email-report-config",
    imports: [
    SvgIconComponent,
        CommonModule,
        DxButtonModule,
        DxDataGridModule,
        DxTagBoxModule,
        DxDropDownBoxModule,
        DxListModule,
        DxToastModule,
        SearchableDropdownDirective,
    ],
    templateUrl: "./email-report-config.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./email-report-config.component.css"]
})
export class EmailReportConfigComponent implements OnInit {
  @ViewChild("emailReportConfigGrid", { static: false })
  emailReportConfigGrid: DxDataGridComponent;
  @ViewChild("userDropDownGrid", { static: false })
  dropdownGrid: DxDataGridComponent;

  emailReportConfig: EmailReportConfigItem[];
  entraUsers: EntraUser[];

  confirmText: any = $localize`:@@confirm:Confirm`;
  cancelText: any = $localize`:@@cancel:Cancel`;

  editingRole: EmailReportRole;
  editingUsers: string[] = [];

  emailReportRole = EmailReportRole; // Add this line to access enum in the template

  toastVisible = false;

  constructor(
    private configService: ConfigService,
    private appGlobals: AppGlobals,
    private activityLog: ActivityLogService
  ) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_EMAIL });
    this.appGlobals.SetGlobalMenuIndex(8);

    this.getPageData();
  }

  getPageData() {
    this.configService.getEmailReportConfig().then((result) => {
      // #5032: only the Geschäftsführer list is configured; everyone else's report
      // follows from who is responsible for what and the "reports to" tree.
      const roles = [EmailReportRole.MANAGING_DIRECTOR];
      const emailReportConfigMap = new Map(
        result.emailReportConfigItems.map((item) => [item.role, item])
      );

      this.emailReportConfig = roles.map((role) => {
        return (
          emailReportConfigMap.get(role as EmailReportRole) || {
            role: role as EmailReportRole,
            users: [],
          }
        );
      });

      this.entraUsers = result.entraUsers;
    });
  }

  getRoleLabel(role): string {
    switch (role) {
      case EmailReportRole.PROJECT_MANAGER:
        return $localize`:@@projectManager:Project Manager`;
      case EmailReportRole.DEPARTMENT_MANAGER:
        return $localize`:@@departmentManager:Department Manager`;
      case EmailReportRole.MANAGING_DIRECTOR:
        return $localize`:@@managingDirector:Managing Director`;
      // Add other cases as needed
      default:
        return $localize`Unknown`;
    }
  }

  getRoleCellValue(e) {
    return this.getRoleLabel(e.role);
  }

  saveEamilReport() {
    this.configService
      .saveEmailReportConfig({ emailReportConfigItems: this.emailReportConfig })
      .then((result) => {
        if (result.hasError) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.toastVisible = true;
        }
      });
  }

  onSaving(e: any) {
    this.emailReportConfig.find(
      (config) => config.role == this.editingRole
    ).users = this.editingUsers;
    this.saveEamilReport();
  }

  getDisplayName(e: any) {
    return `${e.firstName} ${e.lastName}`;
  }

  onTagValueChanged(e: any, role: EmailReportRole) {
    this.emailReportConfig.find((config) => config.role == role).users =
      [...e.value];
    this.saveEamilReport();
  }

  editRow(role: EmailReportRole) {
    let visibleRows = this.emailReportConfigGrid.instance.getVisibleRows();
    let rowIndex = visibleRows.find(
      (row: any) => row.data.role == role
    ).rowIndex;
    this.editingUsers = [
      ...this.emailReportConfig.find((config) => config.role == role)
        .users,
    ];
    this.editingRole = role;
    this.emailReportConfigGrid.instance.editRow(rowIndex);
  }
}
